import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import bindMethods from 'auto-bind';
import ReactTable from 'react-table';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

const ProductsTableContainer = styled.table`
  border-collapse: collapse;
  width: 100%;

  td,
  th {
    text-align: left;
    padding: 14px 0px;
  }

  th {
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    color: ${props => props.theme.BLACK};
  }

  tbody {
    tr {
      cursor: pointer;
    }

    tr:nth-child(odd) {
      background-color: ${props => props.theme.NEUTRAL_GREY};
    }
  }
`;

const StyledNameCell = styled.td`
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  color: ${props => props.theme.BLACK};
`;

const StyledDescriptionCell = styled.td`
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  color: ${props => props.theme.BLACK};
`;

const StyledStatusCell = styled.td`
  display: flex;
  justify-content: start;
`;

const StyledStatusPill = styled.div`
  width: 85px;
  height: 20px;
  border-radius: 30px;
  background-color: ${props => (props.status ? props.theme.SAFE : props.theme.WARNING)};
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    font-size: 12px;
    font-weight: bold;
    color: ${props => props.theme.WHITE};
  }
`;

class ProductsTable extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);

    this.TABLE_COLUMNS = [
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Description',
        accessor: 'description',
      },
      {
        Header: 'Status',
        accessor: 'status',
      },
    ];
  }

  handleTableRowClick(row) {
    const { history } = this.props;
    const { id } = row;

    history.push(`/products/${id}`);
  }

  renderNameCell(row, index) {
    return (
      <StyledNameCell key={`ProductTableRow.name.${row.id}`} id={`ProductTableRow.name.${index}`}>
        {row.name}
      </StyledNameCell>
    );
  }

  renderDescriptionCell(row, index) {
    return (
      <StyledDescriptionCell
        id={`ProductTableRow.description.${index}`}
        key={`ProductTableRow.description.${row.id}`}
      >
        {row.description}
      </StyledDescriptionCell>
    );
  }

  renderStatusCell(row, index) {
    const { t } = this.props;

    const term = row.status ? t('Shared.General.Active') : t('Shared.General.Inactive');
    return (
      <StyledStatusCell
        key={`ProductTableRow.status.${row.id}`}
        id={`ProductTableRow.status.${index}`}
      >
        <StyledStatusPill status={row.status}>
          <span>{term}</span>
        </StyledStatusPill>
      </StyledStatusCell>
    );
  }

  renderTableRow(row, columns, index) {
    return (
      <tr
        id={`ProductTableRow.${index}`}
        key={`ProductTableRow.${row.id}`}
        onClick={this.handleTableRowClick.bind(null, row)}
      >
        {columns.map((column) => {
          switch (column.accessor) {
            case 'name':
              return this.renderNameCell(row, index);
            case 'description':
              return this.renderDescriptionCell(row, index);
            case 'status':
              return this.renderStatusCell(row, index);
            default:
              return null;
          }
        })}
      </tr>
    );
  }

  // eslint-disable-next-line no-unused-vars
  renderProductsTable(state, makeTable, instance) {
    const { columns, data } = state;

    return (
      <ProductsTableContainer id="ProductsTable">
        <thead>
          <tr>
            {columns.map(column => (
              <th
                key={`ProductsTable.${column.Header}`}
                id={`ProductsTable.Header.${column.Header}`}
              >
                {column.Header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{data.map((row, index) => this.renderTableRow(row, columns, index))}</tbody>
      </ProductsTableContainer>
    );
  }

  render() {
    const { products } = this.props;

    return (
      <ReactTable columns={this.TABLE_COLUMNS} data={products}>
        {this.renderProductsTable}
      </ReactTable>
    );
  }
}

ProductsTable.propTypes = {
  history: PropTypes.object.isRequired, // supplied from withRouter
  t: PropTypes.func.isRequired, // supplied from withTranslation
  products: PropTypes.array.isRequired,
};

const TranslatedComponent = withTranslation()(ProductsTable);
export default withRouter(TranslatedComponent);
